<template>
<div id="partner" v-if="id">
  <h2>Partner #{{ partnerId }}</h2>

  <partner-nav
    :partnerId="partnerId"
  ></partner-nav>

  <table class="table">
    <tr>
      <td>
        Name
      </td>
      <td>
        {{ name }}
      </td>
    </tr>
    <tr>
      <td>
        Authentication Token
      </td>
      <td>
        {{ authentication_token }}
      </td>
    </tr>
    <tr>
      <td>
        Slug
      </td>
      <td>
        {{ slug }}
      </td>
    </tr>
    <tr>
      <td>
        Description
      </td>
      <td>
        {{ description }}
      </td>
    </tr>
    <tr>
      <td>
        Inactive?
      </td>
      <td>
        {{ inactive }}
      </td>
    </tr>
    <tr>
      <td>
        Visible?
      </td>
      <td>
        {{ visible }}
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(created_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ this.$root.displayDateTimeFmt(updated_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Apps
      </td>
      <td>
        <table class="table">
          <tr v-for="app in apps">
            <td>
              {{ app.attributes.name }}
            </td>
            <td>
              <a
                :href="'/partners/' + partnerId + '/delete_app/' + app.id"
                v-on:click.prevent="deleteApp"
              >
                Delete?
              </a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
</template>

<script>
import PartnerNav from '@/components/PartnerNav'

import PartnerStore from '@/stores/PartnerStore'

export default {
  data () {
    return PartnerStore.state
  },

  components: {
    'partner-nav': PartnerNav
  },

  props: ['partnerId'],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet('/partners/' + this.partnerId, PartnerStore, true)
    },

    deleteApp (ev) {
      if (confirm('Are you sure you want to delete this app? This action cannot be undone.')) {
        const ele = ev.target

        this.$http.delete(this.apiUrl(ele.getAttribute('href'), true)).then((resp) => {
          this.processSuccess(resp, PartnerStore)
        }, this.processErrors)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Partner.vue